<style lang="sass">
$color-pack: false
@import 'src/assets/style.scss'
</style>

<template>
  <v-app id="inspire" class="customTheme">
    
    <v-app-bar app color="white" light v-if='this.$route.name !== "login"'>
      <v-toolbar-title color="black">
        <img src="./assets/logo.svg" alt="">
      </v-toolbar-title>
      <v-spacer></v-spacer>

       <v-chip @click="redirectToHome" class="ma-2" color="black" small text-color="white">Home </v-chip>

       <v-chip @click="redirectToViewOfflineEnquiries" class="ma-2" color="secondary" small text-color="white">Offline Enquiries</v-chip>

      <offline @detected-condition="handleConnectivityChange">
        <!-- Only renders when the device is online -->
        <div slot="online">
          <v-chip v-if="connectionStatus" class="ma-2" color="success" small text-color="white"> <i class="fs12px mdi mdi-circle mr5px"></i> Online </v-chip>
          <v-chip v-else class="ma-2" color="error" small text-color="white"> <i class="fs12px mdi mdi-circle mr5px"></i> Offline </v-chip>
        </div>
      </offline>



      <!--
      <v-btn icon color="black" class="mr-4">
        <v-badge>
          <template v-slot:badge>0</template>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
      -->

      <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn icon color="black" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
            </v-list-item-avatar>

            <v-list-item-content v-if="objUserLoggedIn">
              <v-list-item-title>{{objUserLoggedIn.name}}</v-list-item-title>
              <v-list-item-subtitle>{{objUserLoggedIn.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item-group v-model="item" color="black">

            <v-list-item link  @click="logout">
              <v-list-item-icon>
                <v-icon >mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-item-group>
          
        </v-list>

      </v-card>
    </v-menu>
      
     
    </v-app-bar>

    <v-content>
      <router-view></router-view>
      
      <v-snackbar v-model="snackbar" :multi-line="true" :bottom="true" :left="true">
      {{ snackbarText }}
      <v-btn color="error" text @click="closeDialog()">Close</v-btn>
    </v-snackbar>

    </v-content>
  </v-app>
</template>

<script>
import offline from "v-offline";
import api from "@/api";

export default {
  name: "App",
  components: {
    offline
  },
  props: {
    source: String
  },
  data: () => ({
    connectionStatus: false,  
    drawer: null,
    menu: false,
    item: '',
    snackbar: false,
    objUserLoggedIn: null,
    //intCountOfflineEnquiries: 0,
    snackbarText: ""
  }),
  methods: {
 
    redirectToHome(){
     
      window.location.href = "/home";
       /*this.$router.push({ path: "/" });      */
    },

    redirectToViewOfflineEnquiries(){
     
      window.location.href = "/offline-enquiries";
       /*this.$router.push({ path: "/" });      */
    },

    logout(){
     
      localStorage.removeItem('objUserLoggedIn');
      localStorage.clear();
      window.location.href = "/";
       /*this.$router.push({ path: "/" });      */
    },
    async handleConnectivityChange(status) {

      this.connectionStatus = status;
      if(this.connectionStatus){
         let intPending =  await api.processOfflineEquiries();
         if(intPending === 0){
           this.openSnackBar("All offline enquiries posted successfully!");
         }
      }

      if(!status){
       // this.openSnackBar("You have gone Offline");
      }else {
     //   this.openSnackBar("You aer now Online");
      }
    },
    openSnackBar(str) {
      this.snackbarText = str;
      this.snackbar = true;
    }
  },
  async created() {
    
      if(localStorage.getItem("objUserLoggedIn")){
         this.objUserLoggedIn = JSON.parse(localStorage.getItem("objUserLoggedIn"));
         //this.intCountOfflineEnquiries = await api.getOfflineEnquiriesCount();
      }
  },
};
</script>
